// extracted by mini-css-extract-plugin
export var arrow = "_jf-1";
export var content = "_jf-0";
export var highlighted = "_jf-2";